(function () {
    "use strict";

    function showToast(message, type) {
        const template = document.getElementById("ns-atc-toast-template");
        if (!template) {
            alert(message);
            return;
        }

        const clone = template.querySelector(".toast").cloneNode(true);
        const id = "ns-toast-" + Date.now();
        clone.setAttribute("id", id);
        clone.classList.add('toast--' + type);

        if (type === 'danger' || type === 'error') {
            clone.classList.add('bg-danger', 'text-white');
        } else if (type === 'success') {
            clone.classList.add('bg-success', 'text-white');
        } else if (type === 'warning') {
            clone.classList.add('bg-warning', 'text-dark');
        }

        const body = clone.querySelector(".toast-body");
        if (body) {
            body.innerHTML = message;
        }

        const container = document.querySelector(".toast-container");
        if (container) {
            container.appendChild(clone);
            if (typeof bootstrap !== 'undefined' && bootstrap.Toast) {
                const toast = new bootstrap.Toast(clone);
                toast.show();
            } else {
                clone.style.display = 'block';
                setTimeout(() => {
                    clone.remove();
                }, 3000);
            }
        } else {
            alert(message);
        }
    }

    function sendCreatePasswordRequest(emailVal = '') {
        const btn = document.querySelector('.negarshop-create-password-btn');
        if (btn) {
            btn.disabled = true;
            btn.classList.add('loading');
        }

        const nonceEl = document.querySelector("input[name='ns_login_nonce']");
        const nonceVal = nonceEl ? nonceEl.value : '';

        const params = new URLSearchParams();
        params.append('action', 'negarshop_smart_login_create_password_request');
        params.append('_nonce', nonceVal);
        params.append('email', emailVal);

        fetch(NS_OBJ.ajax_url, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: params
        })
        .then(res => res.json())
        .then(response => {
            if (btn) {
                btn.disabled = false;
                btn.classList.remove('loading');
            }

            if (response.success) {
                if (response.data.status === 'email_required') {
                    const modalEl = document.getElementById('ns-get-email-modal');
                    if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                        const modal = new bootstrap.Modal(modalEl);
                        modal.show();
                    } else if (modalEl) {
                        modalEl.classList.add('show');
                        modalEl.style.display = 'block';
                    }
                } else {
                    showToast(response.data.message, 'success');
                    const modalEl = document.getElementById('ns-get-email-modal');
                    if (modalEl) {
                        if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                            const modal = bootstrap.Modal.getInstance(modalEl);
                            if (modal) modal.hide();
                        } else {
                            modalEl.classList.remove('show');
                            modalEl.style.display = 'none';
                        }
                    }
                }
            } else {
                const errMsg = response.data.message || response.data || 'خطایی رخ داده است.';
                showToast(errMsg, 'danger');
            }
        })
        .catch(err => {
            console.error(err);
            if (btn) {
                btn.disabled = false;
                btn.classList.remove('loading');
            }
            showToast('خطا در برقراری ارتباط با سرور.', 'danger');
        });
    }

    document.addEventListener('click', function (e) {
        const editPasswordButton = e.target.closest('.password-change-placeholder .button');
        if (editPasswordButton) {
            const passwordFieldset = document.querySelector('.password-change-fieldset');

            if (passwordFieldset) {
                passwordFieldset.style.display = "flex";
            }

            e.target.closest('.password-change-placeholder').style.display = 'none';
            return;
        }

        const createPasswordBtn = e.target.closest('.negarshop-create-password-btn');
        if (createPasswordBtn) {
            const email = createPasswordBtn.getAttribute('data-user-email');
            sendCreatePasswordRequest(email);
            return;
        }

        const submitEmailBtn = e.target.closest('.ns-submit-email-btn');
        if (submitEmailBtn) {
            const emailInput = document.getElementById('ns-user-email-input');
            const emailVal = emailInput ? emailInput.value.trim() : '';

            if (!emailVal) {
                showToast('لطفاً ایمیل خود را وارد کنید.', 'danger');
                return;
            }

            sendCreatePasswordRequest(emailVal);
            return;
        }

        const dismissBtn = e.target.closest('[data-bs-dismiss="modal"]');
        if (dismissBtn) {
            const modalEl = dismissBtn.closest('.modal');
            if (modalEl) {
                if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    const modal = bootstrap.Modal.getInstance(modalEl);
                    if (modal) modal.hide();
                } else {
                    modalEl.classList.remove('show');
                    modalEl.style.display = 'none';
                }
            }
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            const emailInput = e.target.closest('#ns-user-email-input');
            if (emailInput) {
                e.preventDefault();
                const submitEmailBtn = document.querySelector('.ns-submit-email-btn');
                if (submitEmailBtn) {
                    submitEmailBtn.click();
                }
            }
        }
    });
})();
